import React, { useEffect, useRef } from "react";
import "../components/About.css";
import profileIMG from "../profile.jpg";
export default function About() {
  const aboutRef = useRef(null);
  const effectRef = useRef(null);

  useEffect(() => {
    const loadVanta = async () => {
      // Load THREE.js
      const threeScript = document.createElement("script");
      threeScript.src =
        "https://cdn.jsdelivr.net/npm/three@0.124.0/build/three.min.js";
      threeScript.async = true;

      threeScript.onload = () => {
        // Load Vanta.DOTS
        const vantaScript = document.createElement("script");
        vantaScript.src =
          "https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.dots.min.js";
        vantaScript.async = true;

        vantaScript.onload = () => {
          if (!effectRef.current && window.VANTA?.DOTS) {
            effectRef.current = window.VANTA.DOTS({
              el: aboutRef.current,
              THREE: window.THREE,
              backgroundColor: 0x000000,
              color: 0xff00ff,
              size: 1.0,
              spacing: 10.0,
              showLines: false,
              scale: 1.0,
              scaleMobile: 0.7,
            });
          }
        };

        document.body.appendChild(vantaScript);
      };

      document.body.appendChild(threeScript);
    };

    loadVanta();

    return () => {
      effectRef.current?.destroy();
    };
  }, []);

  return (
    <section id="about" className="about" ref={aboutRef}>
      <div className="about-wrapper">
        <div className="about-img" data-aos="fade-right">
          <img src={profileIMG} alt="Ankush" />
        </div>
        <div className="about-text" data-aos="fade-left">
          <h2>Why Should You Hire Me?</h2>
          <p>
            I bring clean code, smart design, and performance-first development
            to every project. From frontend to backend, I make full-stack apps
            that actually solve problems.
          </p>
          <ul>
            <li>✔️ 2+ years of full-stack experience</li>
            <li>✔️ Strong in React, Node.js, MongoDB</li>
            <li>✔️ Pixel-perfect UI with responsive design</li>
            <li>✔️ Great at working with teams and deadlines</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
